import React, { Component } from "react"
import { Container } from "reactstrap"
import PricingTable from "./PricingTable"
import './Pricing.css'
import PricingListHeader from "./PricingListHeader"
import RestrictedSection from "../Components/RestrictedSection"
import { usePresetFilters } from '../Filters/presetFilters'

// Editable, visible default: the list opens showing active pricing; the user can
// flip it to false or drop it entirely from the Advanced Filters popover/chips.
const IS_ACTIVE_PRESET = [
    { fieldName: "is_active", filterType: "equal", filterValues: "true", editable: true, visible: true },
]

class PricingContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      openModal: "",
      refetchPricing: false,
      filterValues: {},
      orderBy: ["-id"],
      selectedPricing: [],
    }
  }

  toggleModal = (name) => {
    this.setState({ openModal: this.state.openModal === name ? "" : name })
  };

  updateOrder = (string) => {
    let orderBy = [...this.state.orderBy]
    let index = orderBy.indexOf(string)
    if (index > -1) {
      orderBy[index] = "-" + string
    } else {
      index = orderBy.indexOf("-" + string)
      index > -1 ? orderBy.splice(index, 1) : orderBy.unshift(string)
    }
    this.setState({ orderBy })
  };

  render() {
    return (
      <RestrictedSection requiredPermission="view_pricingtemplate">
        <Container fluid className="pricing-list-container">
          <PricingListHeader
            filterValues={this.state.filterValues}
            setFilterValues={(filterValues) => this.setState({ filterValues })}
            refetchQuery={() => this.setState((prevState) => ({ refetchPricing: !prevState.refetchPricing }))}
            selectedPricing={this.state.selectedPricing} location={this.props.location} history={this.props.navigate}
            resetSelectedPricing={() => this.setState({ selectedPricing: [] })}
            presets={this.props.presets}
            setPresets={this.props.setPresets}
            defaultPresets={this.props.defaultPresets}
          />
          <PricingTable
            key={String(this.state.refetchPricing)}
            searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
            orderBy={this.state.orderBy}
            updateOrder={(headerId) => this.updateOrder(headerId)}
            selectedPricing={this.state.selectedPricing}
            setSelectedPricing={(selectedPricing) => this.setState({ selectedPricing })}
            presets={this.props.presets}
          />
        </Container>
      </RestrictedSection>
    )
  }
}

// Preset state is owned here so both the header (popover + chips) and the list
// (query variables) share one source of truth.
export default function PricingContainerWithFilters(props) {
  const [presets, setPresets, defaultPresets] = usePresetFilters(IS_ACTIVE_PRESET)
  return <PricingContainer {...props} presets={presets} setPresets={setPresets} defaultPresets={defaultPresets} />
}
